import React from "react";

export default function PrivacyPolicy() {
  return (
    <section style={{ maxWidth: 760 }}>
      <h2 className="section-title">Политика обработки персональных данных</h2>

      <div style={{
        background: "#fff1f6", border: "1.5px solid #e5005b", borderRadius: 10,
        padding: "12px 16px", marginBottom: 20, fontSize: "0.9rem", color: "#9c0040",
      }}>
        ⚠️ Черновик документа, требующий заполнения реквизитов оператора и юридической
        проверки перед публикацией. Поля вида [ЗАПОЛНИТЬ: …] должны быть заменены реальными
        данными до того, как сайт начнёт фактическую обработку персональных данных пользователей.
        Раздел 6.1 ниже отмечен отдельно — он описывает признак, требующий прицельного внимания
        юриста (обработка данных пациентов через раздел «Второе мнение»).
      </div>

      <div className="article-body">
        <p>Действует с [ЗАПОЛНИТЬ: дата вступления в силу].</p>

        <h3>1. Общие положения</h3>
        <p>
          Настоящая Политика определяет порядок обработки персональных данных пользователей
          сайта «Современный Врач» (далее — «Портал», доступен по адресу svrach.ru)
          в соответствии с Федеральным законом от 27.07.2006 № 152-ФЗ «О персональных данных».
        </p>
        <p>
          Оператором персональных данных является [ЗАПОЛНИТЬ: ФИО/наименование и организационно-
          правовая форма — самозанятый / ИП / ООО], ИНН [ЗАПОЛНИТЬ: ИНН] (далее — «Оператор»).
        </p>

        <h3>2. Какие данные обрабатываются</h3>
        <p>При использовании Портала Оператор обрабатывает следующие данные:</p>
        <p><strong>Данные учётной записи:</strong></p>
        <ul>
          <li>email, указанный при регистрации, и его статус подтверждения;</li>
          <li>отображаемое имя и имя пользователя (@username для упоминаний в чате);</li>
          <li>хеш пароля (для регистрации по email) либо идентификатор OAuth-провайдера
            (Яндекс или Mail.ru) — данные, предоставленные провайдером в рамках запрошенных
            разрешений (email, имя);</li>
          <li>специальность (медицинская специализация), если указана пользователем.</li>
        </ul>
        <p><strong>Данные публичного профиля (заполняются пользователем добровольно):</strong></p>
        <ul>
          <li>фотография профиля;</li>
          <li>текст «о себе» на странице профиля;</li>
          <li>статистика публикаций (просмотры, реакции, комментарии, количество цитирований
            материалов в ответах ИИ-поиска) — отображается на публичной странице автора;</li>
          <li>видимость в справочнике коллег — управляется самим пользователем (отдельная
            настройка «показывать в справочнике»); страница профиля по прямой ссылке доступна
            независимо от этой настройки, как и страница любой опубликованной статьи.</li>
        </ul>
        <p><strong>Данные верификации врача (доступ ограничен — см. раздел 8):</strong></p>
        <ul>
          <li>скан или фотография диплома/сертификата, загруженные для подтверждения
            квалификации, и статус рассмотрения заявки администратором.</li>
        </ul>
        <p><strong>Контент и активность на Портале:</strong></p>
        <ul>
          <li>содержимое сообщений в чате, комментариев, публикуемых статей/случаев,
            голосований в опросах и оценок/отзывов на материалы и события;</li>
          <li>текст откликов на позицию ответственного редактора раздела (специальность, сведения
            о себе, указанные в отклике);</li>
          <li>история запросов к ИИ-поиску — используется для формирования персональных
            рекомендаций материалов на главной странице;</li>
          <li>настройка получения еженедельного email-дайджеста и статус подписки/отписки.</li>
        </ul>
        <p><strong>Технические данные:</strong></p>
        <ul>
          <li>технические данные push-подписки браузера — только если пользователь включил
            уведомления;</li>
          <li>IP-адрес и данные журналов сервера — в целях обеспечения работы и безопасности
            Портала.</li>
          <li>обезличенная статистика посещений: случайный код браузера, время и адрес открытых
            страниц, источник перехода, тип устройства, время нахождения на странице и глубина
            прокрутки. Эти данные не связываются с учётной записью, именем или IP-адресом, хранятся
            на серверах Портала и не передаются третьим лицам. Сбор не выполняется, если в браузере
            включён сигнал «Не отслеживать».</li>
        </ul>
        <p><strong>Вход на связанные сайты:</strong></p>
        <ul>
          <li>если вы решите войти через «Современный врач» на другой сайт, перед передачей данных вы увидите,
            какой оператор персональных данных их получит, с какой целью и какие сведения будут переданы
            (имя, адрес электронной почты и подтверждена ли она, специальность, статус подтверждения врача);
            пароль не передаётся никогда;</li>
          <li>передача выполняется только после вашего явного согласия на экране входа; список сайтов, которым вы
            дали согласие, и кнопка «Отозвать доступ» находятся в вашем профиле;</li>
          <li>при отзыве согласия или удалении аккаунта сайт получает уведомление об этом и перестаёт получать
            ваши данные; сведения, уже полученные оператором этого сайта, он обрабатывает по собственной политике
            конфиденциальности, ссылка на которую показана на экране согласия.</li>
        </ul>

        <h3>3. Цели обработки</h3>
        <ul>
          <li>регистрация и идентификация пользователя, авторизация в системе;</li>
          <li>предоставление функций Портала: публикация и чтение статей, лекций, клинических
            случаев; участие в обсуждениях, комментариях и опросах; ИИ-поиск по материалам
            Портала и клиническим рекомендациям; поиск лекарственных препаратов; формирование
            профиля и справочника врачей; получение и предоставление второго мнения по
            диагностическим записям (см. раздел 6.1);</li>
          <li>верификация квалификации врача для присвоения статуса «Подтверждённый врач»;</li>
          <li>направление push-уведомлений и еженедельного email-дайджеста — только с согласия
            пользователя, отзываемого в любой момент через настройки профиля или ссылку
            отписки в письме;</li>
          <li>обеспечение безопасности и предотвращение злоупотреблений.</li>
        </ul>

        <h3>4. Правовое основание обработки</h3>
        <p>
          Обработка осуществляется на основании согласия субъекта персональных данных,
          предоставляемого при регистрации на Портале (отметка чекбокса) либо при входе
          через OAuth-провайдера (продолжение использования Портала после авторизации
          расценивается как согласие с настоящей Политикой).
        </p>

        <h3>5. Передача данных третьим лицам</h3>
        <p>
          Оператор не передаёт персональные данные третьим лицам, за исключением случаев:
        </p>
        <ul>
          <li>взаимодействия с OAuth-провайдерами (Яндекс, Mail.ru) — исключительно в рамках
            процедуры авторизации, инициированной самим пользователем;</li>
          <li>обращения к YandexGPT и Yandex SpeechKit (Яндекс) для формирования ответов
            ИИ-поиска, еженедельного дайджеста и озвучки статей — тексту запроса/материала
            присваивается статус, определяемый условиями обработки данных самого сервиса
            Яндекса; [ЗАПОЛНИТЬ: уточнить у юриста статус этой передачи — поручение обработки
            или самостоятельный оператор — и необходимость отдельного пункта соглашения];</li>
          <li>отправки push-уведомлений через стандартный Web Push API браузера
            (Google/Apple/Mozilla выступают техническими посредниками доставки);</li>
          <li>отправки email через провайдера SMTP [ЗАПОЛНИТЬ: наименование провайдера];</li>
          <li>требований законодательства РФ (по запросу уполномоченных государственных органов).</li>
        </ul>

        <h3>6. Хранение и локализация данных</h3>
        <p>
          Персональные данные пользователей — граждан РФ хранятся и обрабатываются на сервере,
          физически расположенном на территории Российской Федерации, в соответствии
          с требованиями ч. 5 ст. 18 152-ФЗ.
        </p>
        <p>
          Данные хранятся до момента удаления аккаунта пользователем либо до отзыва согласия
          на обработку персональных данных, после чего удаляются или обезличиваются
          в течение разумного срока, необходимого для технической обработки запроса.
        </p>

        <h3 style={{ color: "#c0392b" }}>6.1. Второе мнение: данные, относящиеся к пациенту</h3>
        <p>
          Раздел «Второе мнение» позволяет врачу загрузить нативный файл записи прибора
          (ЭКГ, Холтеровское мониторирование, СМАД) для получения экспертного заключения.
          <strong> Такой файл может содержать данные, относящиеся не к пользователю Портала,
          а к пациенту</strong> — в частности, форматы записи ряда приборов включают в заголовок
          файла ФИО и дату рождения пациента, проставленные диагностическим оборудованием
          при формировании записи.
        </p>
        <p>
          Загружая запись, врач-пользователь подтверждает, что действует в рамках своих
          профессиональных обязанностей и на предусмотренных законодательством РФ основаниях
          для передачи данных пациента третьему лицу (эксперту-рецензенту Портала) в целях
          получения консультации по диагностике — либо что запись деперсонализирована.
          Файлы записей хранятся на выделенном сервере, отдельном от основной базы Портала,
          доступ к ним имеют только сам загрузивший врач и назначенный эксперт.
        </p>
        <p style={{ background: "#fef2f2", border: "1px solid #fecaca", borderRadius: 8, padding: "10px 14px" }}>
          [ЗАПОЛНИТЬ ПОСЛЕ КОНСУЛЬТАЦИИ С ЮРИСТОМ: это первый раздел Портала, где Оператор
          выступает получателем данных о здоровье третьего лица (специальная категория
          персональных данных по ст. 10 152-ФЗ), переданных не самим субъектом, а врачом.
          Нужно определить: (а) на кого возлагается ответственность за законность передачи —
          на загружающего врача или совместно на Оператора; (б) нужна ли отдельная форма
          подтверждения при загрузке (чекбокс «подтверждаю законность передачи данных
          пациента» или «запись деперсонализирована»); (в) отдельный срок хранения и порядок
          удаления записей после получения заключения. Раздел выключен в проде до решения
          этих вопросов и подключения выделенного сервера хранения.]
        </p>

        <h3>7. Права субъекта персональных данных</h3>
        <p>Пользователь вправе:</p>
        <ul>
          <li>получить информацию о составе и источниках своих персональных данных;</li>
          <li>требовать уточнения, блокирования или уничтожения своих персональных данных,
            если они неполны, устарели, неточны или незаконно получены;</li>
          <li>отозвать согласие на обработку персональных данных;</li>
          <li>самостоятельно удалить свой аккаунт и связанные данные через раздел
            «Профиль» на Портале — это исполняет право на удаление немедленно;</li>
          <li>отписаться от email-дайджеста ссылкой в письме, не заходя на Портал;</li>
          <li>обратиться с жалобой в Роскомнадзор, если считает, что его права нарушены.</li>
        </ul>

        <h3>8. Меры защиты данных</h3>
        <ul>
          <li>соединение с Порталом защищено протоколом HTTPS (TLS-шифрование);</li>
          <li>пароли хранятся в виде необратимых криптографических хешей (bcrypt),
            Оператор не имеет доступа к паролям пользователей в открытом виде;</li>
          <li>документы верификации врача (сканы дипломов) хранятся отдельно от публично
            доступных файлов Портала и выдаются только администратору по защищённому запросу;</li>
          <li>файлы записей «Второго мнения» хранятся на отдельном от основной базы сервере,
            доступ ограничен загрузившим врачом и назначенным экспертом;</li>
          <li>доступ к административным функциям ограничен ролевой моделью;</li>
          <li>регулярное резервное копирование базы данных.</li>
        </ul>

        <h3>9. Контакты по вопросам персональных данных</h3>
        <p>
          По вопросам обработки персональных данных, включая запросы на доступ, исправление
          или удаление данных, обращайтесь: [ЗАПОЛНИТЬ: контактный email — уточнить, тот же
          info@svrach.ru или отдельный адрес].
        </p>

        <h3>10. Изменения Политики</h3>
        <p>
          Оператор вправе вносить изменения в настоящую Политику. Актуальная редакция всегда
          доступна по адресу /privacy. Существенные изменения будут анонсированы на Портале.
        </p>
      </div>
    </section>
  );
}
